var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomationSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_232)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8632 24.5668L43.5813 25.6215L43.0758 27.5073L38.9818 26.4123L38.5863 27.8807L35.4515 27.0421L34.8837 29.155L38.022 29.9976L37.6852 31.2462L41.7797 32.3411L40.3442 37.6987L36.2497 36.6038L35.8618 38.0431L32.727 37.2044L32.1592 39.321L35.294 40.1596L34.9535 41.4378L39.0475 42.5328L37.5792 48.0043L33.4885 46.9091L33.1406 48.2129L30.0023 47.3705L29.4345 49.4836L32.5728 50.3259L32.1919 51.7432L36.2826 52.8382L34.8763 58.0824L30.7858 56.9873L30.4489 58.247L27.3106 57.4047L26.7466 59.5178L29.8813 60.3563L29.4896 61.8247L33.5801 62.9198L33.0563 64.8754L32.7745 65.9336L33.8327 66.2157L63.6973 74.2172L64.7555 74.4994L65.0377 73.441L65.5613 71.4892L69.641 72.5806L70.0326 71.1158L73.2004 71.9654L73.7681 69.8522L70.6003 69.0026L70.9372 67.7429L66.8579 66.6516L68.2641 61.4075L72.3434 62.4987L72.7243 61.0815L75.8922 61.9311L76.4561 59.8182L73.2885 58.9686L73.6401 57.6611L69.5603 56.5697L71.0252 51.1022L75.1049 52.1936L75.4453 50.9191L78.6128 51.7687L79.1806 49.6519L76.013 48.8023L76.3974 47.3597L72.3216 46.2682L73.7572 40.9104L77.833 42.0019L78.1662 40.7568L81.3373 41.6064L81.9051 39.4897L78.7337 38.64L79.1292 37.1643L75.0534 36.0728L75.5587 34.1906L75.8442 33.1323L74.786 32.8464L44.9213 24.8484L43.8631 24.5665L43.8632 24.5668ZM45.4087 27.2473L73.1636 34.6812L63.2067 71.8191L35.455 64.3847L45.4087 27.2473ZM67.9781 35.5601L59.8007 66.0804L39.2562 60.5726L38.6887 62.689L60.2953 68.4793L61.3499 68.7612L61.6354 67.703L70.0949 36.128L67.9782 35.5605L67.9781 35.5601Z",
    fill: "#8FB16A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_232",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.694118 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_232",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationSystem);
export default __webpack_public_path__ + "static/media/automationSystem.a56b88e5cf132c2d8556c105eb622903.svg";
export { ForwardRef as ReactComponent };